
import { useRef } from "react";

export const useInteractionGuards = () => {
  const formStartTime = useRef(Date.now());
  const mouseMoveCount = useRef(0);
  const keyPressCount = useRef(0);
  const lastAttemptTime = useRef(0);

  const isTooFast = (): boolean => {
    const elapsedMs = Date.now() - formStartTime.current;
    return elapsedMs < 1500; // Form filled too quickly (less than 1.5 seconds)
  };

  const hasLowInteractionCount = (): boolean => {
    return mouseMoveCount.current < 3 && keyPressCount.current < 5;
  };

  const isRateLimited = (): boolean => {
    return lastAttemptTime.current > 0 && (Date.now() - lastAttemptTime.current) < 2000;
  };

  const trackUserInteraction = () => {
    mouseMoveCount.current += 1;
  };

  const trackKeyPress = () => {
    keyPressCount.current += 1;
  };

  const resetAll = () => {
    formStartTime.current = Date.now();
    mouseMoveCount.current = 0;
    keyPressCount.current = 0;
    // Don't reset lastAttemptTime.current--this lets us use it across form mode toggles
  };

  const registerAttempt = () => {
    lastAttemptTime.current = Date.now();
  };

  return {
    isTooFast,
    hasLowInteractionCount,
    isRateLimited,
    trackUserInteraction,
    trackKeyPress,
    resetAll,
    registerAttempt
  };
};
